module.exports = __webpack_public_path__ + "static/yinka-deaed9bef2e7421d6bf2104a63365d0c.png";